/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOnboardingThirdPartyBody
 */
export interface CreateOnboardingThirdPartyBody {
    /**
     * 
     * @type {string}
     * @memberof CreateOnboardingThirdPartyBody
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOnboardingThirdPartyBody
     */
    description?: string;
}

export function CreateOnboardingThirdPartyBodyFromJSON(json: any): CreateOnboardingThirdPartyBody {
    return CreateOnboardingThirdPartyBodyFromJSONTyped(json, false);
}

export function CreateOnboardingThirdPartyBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOnboardingThirdPartyBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function CreateOnboardingThirdPartyBodyToJSON(value?: CreateOnboardingThirdPartyBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'description': value.description,
    };
}


